module.exports = __webpack_public_path__ + "img/marker_office.59c3604a.png";